import React from 'react';
import MapGenerator from './MapGenerator';

function App() {
  return (
    <div>
      <MapGenerator />
    </div>
  );
}

export default App;
